/**
 * A language's name for people, in the reader's language — "Spanish",
 * "espanhol" — from its ISO 639-1 code.
 *
 * `Intl.DisplayNames` names every language in every locale the platform
 * speaks, so a language a citizen tested in needs no translation key of its
 * own. A runtime without it (Hermes, the phone) gets the code upper-cased:
 * a stable, recognisable label rather than nothing.
 */
export function formatLanguageName(code: string, intlLocale: string): string {
  if (typeof Intl.DisplayNames !== 'function') return code.toUpperCase();
  return (
    new Intl.DisplayNames([intlLocale], { type: 'language', fallback: 'code' }).of(code) ??
    code.toUpperCase()
  );
}
